/**
 * @generated SignedSource<<705c41b65f0364f33cc5d8ace96b3876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type selectedIssueStateOld_issueNavigator_SelectedIssueContainer$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly key: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly issueNavigatorPageInfo: {
    readonly firstIssueKeyFromNextPage: string | null | undefined;
    readonly firstIssuePosition: number | null | undefined;
    readonly lastIssueKeyFromPreviousPage: string | null | undefined;
    readonly lastIssuePosition: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer";
};
export type selectedIssueStateOld_issueNavigator_SelectedIssueContainer$key = {
  readonly " $data"?: selectedIssueStateOld_issueNavigator_SelectedIssueContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"selectedIssueStateOld_issueNavigator_SelectedIssueContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssueNavigatorPageInfo",
      "kind": "LinkedField",
      "name": "issueNavigatorPageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "firstIssuePosition"
        },
        {
          "kind": "ScalarField",
          "name": "lastIssuePosition"
        },
        {
          "kind": "ScalarField",
          "name": "firstIssueKeyFromNextPage"
        },
        {
          "kind": "ScalarField",
          "name": "lastIssueKeyFromPreviousPage"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "337a019a583c3a28f545e54926fd4e34";

export default node;
